import { render, staticRenderFns } from "./penawaran-produk.vue?vue&type=template&id=70b71769&"
import script from "./penawaran-produk.vue?vue&type=script&lang=js&"
export * from "./penawaran-produk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports